/*global ContentService:true*/
try {
  module.exports = ContentService;
}
catch (e) {
  /*empty*/
}